// src/views/login/register.service.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/',
  timeout: 15000,
});

export const registerRequest = async ({ nombre, email, password, clave }) => {
  const { data } = await api.post('/api/register', {
    nombre,
    email,
    password,
    clave,
  });

  return data; // { success, error, ... }
};
